import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { GalleryComponent } from './gallery/gallery.component';
import { HomeComponent } from './home/home.component';
import { WorkComponent } from './work/work.component';
import { PublishComponent } from './publish/publish.component';
import { CustomertestComponent } from './customertest/customertest.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
   { path: 'contact', component: ContactUsComponent },
   { path: 'gallery', component: GalleryComponent },
  { path: 'process', loadChildren: () => import('./process/process.module').then(m => m.ProcessModule) },
  { path: 'services', loadChildren: () => import('./servicespage/servicespage.module').then(m => m.ServicespageModule) },
  { path: 'design', loadChildren: () => import('./design/design.module').then(m => m.DesignModule) },
  { path: 'construction', loadChildren: () => import('./construction/construction.module').then(m => m.ConstructionModule) },
  { path: 'about', loadChildren: () => import('./about/about.module').then(m => m.AboutModule) },
  { path: 'admin/v2/manage', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) },
  { path: 'work/:id', component: WorkComponent },
  { path: 'publish', component: PublishComponent },
  { path: 'testimonials', component: CustomertestComponent }
  ];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: false, scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
